import { render } from "./ResultsGridnew.vue?vue&type=template&id=6609e1eb&scoped=true"
import script from "./ResultsGridnew.vue?vue&type=script&lang=js"
export * from "./ResultsGridnew.vue?vue&type=script&lang=js"

import "./ResultsGridnew.vue?vue&type=style&index=0&id=6609e1eb&lang=scss"
import "./ResultsGridnew.vue?vue&type=style&index=1&id=6609e1eb&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3706327227/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6609e1eb"]])

export default __exports__